export default __webpack_public_path__ + "static/media/mc_4.eb053bc8.png";